import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  FormControl,
  FormGroup,
  Pagination,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  deleteServicePartner,
  getServicePartners,
  updateServicePartnerStatus,
} from "api/service partner/PartnerApi";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
import { PARTNER_FEATURES } from "./partnerFormUtils";
import "./partners.css";

class ViewPartners extends Component {
  messageTimer = null;
  partnersRequestId = 0;
  appliedFilters = { name: "", mobile: "", type: "", status: "" };

  state = {
    partners: [],
    name: "",
    mobile: "",
    type: "",
    status: "",
    message: "",
    loading: false,
    currentPage: 1,
    lastPage: 1,
    total: 0,
    from: 0,
    to: 0,
    perPage: 100,
    deletingId: null,
    updatingStatusId: null,
    messageType: "success",
    alert: null,
  };

  componentDidMount() {
    this.loadPartners(1);
  }

  componentWillUnmount() {
    this.partnersRequestId += 1;
    this.clearMessageTimer();
  }

  clearMessageTimer = () => {
    if (this.messageTimer) {
      clearTimeout(this.messageTimer);
      this.messageTimer = null;
    }
  };

  dismissMessage = () => {
    this.clearMessageTimer();
    this.setState({ message: "" });
  };

  showMessage = (message, messageType = "success") => {
    this.clearMessageTimer();
    this.setState({ message, messageType });

    if (messageType === "success") {
      this.messageTimer = setTimeout(() => {
        this.messageTimer = null;
        this.setState({ message: "" });
      }, 4000);
    }
  };

  loadPartners = (page = 1) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const requestId = ++this.partnersRequestId;
    const name = this.state.name.trim();
    const mobile = this.state.mobile.replace(/\D/g, "");
    const type = this.state.type;
    const status = this.state.status;
    const perPage = this.state.perPage;

    this.appliedFilters = { name, mobile, type, status };

    this.clearMessageTimer();
    this.setState({ loading: true, message: "" });
    return getServicePartners(name, mobile, page, perPage, obj, status, type)
      .then((res) => {
        if (requestId !== this.partnersRequestId) {
          return;
        }
        const pagination = res && res.data ? res.data : {};
        this.setState({
          partners: Array.isArray(pagination.data) ? pagination.data : [],
          loading: false,
          currentPage: pagination.current_page || 1,
          lastPage: pagination.last_page || 1,
          total: pagination.total || 0,
          from: pagination.from || 0,
          to: pagination.to || 0,
          perPage: pagination.per_page || 100,
        });
      })
      .catch((error) => {
        if (requestId !== this.partnersRequestId) {
          return;
        }
        this.setState({
          partners: [],
          loading: false,
          total: 0,
          from: 0,
          to: 0,
        });
        this.showMessage(getApiErrorMessage(error), "danger");
      });
  };

  getPageNumbers = () => {
    const { currentPage, lastPage } = this.state;
    const start = Math.max(1, Math.min(currentPage - 2, lastPage - 4));
    const end = Math.min(lastPage, start + 4);
    const pages = [];

    for (let page = start; page <= end; page += 1) {
      pages.push(page);
    }

    return pages;
  };

  editPartner = (partner) => {
    this.props.history.push("/admin/edit-Service-Partner-Branch/" + partner.id);
  };

  createPartnerUser = (partner) => {
    this.props.history.push("/admin/add-user", {
      role: "21",
      createdPartnerId: partner.id,
      fromFulfillmentPartners: true,
    });
  };

  updateFilter = (field, value) => {
    const filters = {
      name: this.state.name,
      mobile: this.state.mobile,
      type: this.state.type,
      status: this.state.status,
      [field]: value,
    };

    this.setState({ [field]: value }, () => {
      const hasName = filters.name.trim() !== "";
      const hasMobile = filters.mobile.replace(/\D/g, "") !== "";
      const hasAppliedFilters = Boolean(
        this.appliedFilters.name ||
        this.appliedFilters.mobile ||
        this.appliedFilters.type ||
        this.appliedFilters.status,
      );

      if (
        !hasName &&
        !hasMobile &&
        !filters.type &&
        !filters.status &&
        hasAppliedFilters
      ) {
        this.loadPartners(1);
      }
    });
  };

  partnerFeatureLabel = (type) => {
    const definition = PARTNER_FEATURES.find(
      (feature) => feature.type === type,
    );

    return definition ? definition.label : type;
  };

  partnerSubtypeLabel = (type, subtype) => {
    const definition = PARTNER_FEATURES.find(
      (feature) => feature.type === type,
    );
    const option =
      definition && definition.subtypes.find((item) => item.value === subtype);

    return option ? option.label : subtype;
  };

  confirmDelete = (partner) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Change partner to inactive?"
          onConfirm={() => this.removePartner(partner)}
          onCancel={() => this.setState({ alert: null })}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          confirmBtnText="Yes, change status"
          cancelBtnText="Cancel"
          showCancel
        >
          {partner.partner_name} will be marked as inactive.
        </SweetAlert>
      ),
    });
  };

  removePartner = (partner) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const page =
      this.state.partners.length === 1 && this.state.currentPage > 1
        ? this.state.currentPage - 1
        : this.state.currentPage;

    this.setState({
      alert: null,
      deletingId: partner.id,
      message: "",
    });
    deleteServicePartner(partner.id, obj)
      .then(() => this.loadPartners(page))
      .then(() => {
        this.setState({ deletingId: null });
        this.showMessage(
          partner.partner_name + " was deactivated successfully.",
        );
      })
      .catch((error) => {
        this.setState({ deletingId: null });
        this.showMessage(getApiErrorMessage(error), "danger");
      });
  };

  activatePartner = (partner) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ updatingStatusId: partner.id, message: "" });
    updateServicePartnerStatus(partner.id, true, obj)
      .then(() => this.loadPartners(this.state.currentPage))
      .then(() => {
        this.setState({ updatingStatusId: null });
        this.showMessage(partner.partner_name + " was activated successfully.");
      })
      .catch((error) => {
        this.setState({ updatingStatusId: null });
        this.showMessage(getApiErrorMessage(error), "danger");
      });
  };

  render() {
    return (
      <Grid fluid>
        {this.state.alert}
        <Row>
          <Col md={12}>
            <Card
              content={
                <div className="partners-page">
                  {this.state.message && (
                    <div
                      role="alert"
                      aria-live="polite"
                      className={
                        "alert alert-" +
                        this.state.messageType +
                        " partners-alert"
                      }
                    >
                      <span>{this.state.message}</span>
                      <button
                        type="button"
                        className="close"
                        aria-label="Dismiss notification"
                        onClick={this.dismissMessage}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  )}
                  <div className="partners-toolbar partners-toolbar-actions">
                    <Button
                      bsStyle="info"
                      fill
                      onClick={() =>
                        this.props.history.push(
                          "/admin/Create-Service-Partner-Branch",
                        )
                      }
                    >
                      <i className="fa fa-plus partners-button-icon" />
                      Create Service Partner
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      fill
                      style={{
                        backgroundColor: "#YOUR_LOGIN_COLOR",
                        borderColor: "#YOUR_LOGIN_COLOR",
                      }}
                      onClick={() =>
                        this.props.history.push("/admin/add-user", {
                          role: "21",
                          fromFulfillmentPartners: true,
                        })
                      }
                    >
                      <i className="fas fa-user-plus partners-button-icon" />
                      Create Service Partner Branch Login
                    </Button>
                  </div>

                  <div className="partners-filter-card">
                    <div className="partners-filter-heading">
                      <div>
                        <h5>Search Service Partner By :</h5>
                      </div>
                      {(this.state.name ||
                        this.state.mobile ||
                        this.state.type ||
                        this.state.status) && (
                        <button
                          type="button"
                          className="partners-clear-button"
                          onClick={() =>
                            this.setState(
                              {
                                name: "",
                                mobile: "",
                                type: "",
                                status: "",
                              },
                              () => this.loadPartners(1),
                            )
                          }
                        >
                          Clear all
                        </button>
                      )}
                    </div>
                    <Row>
                      <Col md={12}>
                        <form
                          onSubmit={(event) => {
                            event.preventDefault();
                            this.loadPartners(1);
                          }}
                        >
                          <div className="partners-filter-grid">
                            <div className="partners-filter-field">
                              <FormGroup>
                                <label className="partners-filter-label">
                                  Service Partner Name
                                </label>
                                <FormControl
                                  value={this.state.name}
                                  placeholder="Enter partner name"
                                  onChange={(event) =>
                                    this.updateFilter(
                                      "name",
                                      event.target.value,
                                    )
                                  }
                                />
                              </FormGroup>
                            </div>
                            <div className="partners-filter-field">
                              <FormGroup>
                                <label className="partners-filter-label">
                                  Mobile Number
                                </label>
                                <FormControl
                                  value={this.state.mobile}
                                  placeholder="Enter mobile number"
                                  type="tel"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  onChange={(event) => {
                                    this.updateFilter(
                                      "mobile",
                                      event.target.value.replace(/\D/g, ""),
                                    );
                                  }}
                                />
                              </FormGroup>
                            </div>
                            <div className="partners-filter-field">
                              <FormGroup>
                                <label className="partners-filter-label">
                                  Service Partner Type
                                </label>
                                <FormControl
                                  componentClass="select"
                                  value={this.state.type}
                                  onChange={(event) =>
                                    this.updateFilter(
                                      "type",
                                      event.target.value,
                                    )
                                  }
                                >
                                  <option value="">All</option>
                                  {PARTNER_FEATURES.map((feature) => (
                                    <option
                                      key={feature.type}
                                      value={feature.type}
                                    >
                                      {feature.label}
                                    </option>
                                  ))}
                                </FormControl>
                              </FormGroup>
                            </div>
                            <div className="partners-filter-field">
                              <FormGroup>
                                <label className="partners-filter-label">
                                  Status
                                </label>
                                <FormControl
                                  componentClass="select"
                                  value={this.state.status}
                                  onChange={(event) =>
                                    this.updateFilter(
                                      "status",
                                      event.target.value,
                                    )
                                  }
                                >
                                  <option value="">All</option>
                                  <option value="1">Active</option>
                                  <option value="0">Inactive</option>
                                </FormControl>
                              </FormGroup>
                            </div>
                            <div className="partners-filter-actions">
                              <Button
                                bsStyle="info"
                                fill
                                type="submit"
                                className="partners-search-button"
                              >
                                <i className="fa fa-search partners-button-icon" />
                                Search
                              </Button>
                              <Button
                                bsStyle="default"
                                fill
                                type="button"
                                className="partners-reset-button"
                                onClick={() =>
                                  this.setState(
                                    {
                                      name: "",
                                      mobile: "",
                                      type: "",
                                      status: "",
                                    },
                                    () => this.loadPartners(1),
                                  )
                                }
                              >
                                Reset
                              </Button>
                            </div>
                          </div>
                        </form>
                      </Col>
                    </Row>
                  </div>

                  <div className="partners-results-header">
                    <strong>
                      {this.state.total}{" "}
                      {this.state.total === 1 ? "partner" : "partners"}
                    </strong>
                    <span>found</span>
                  </div>
                  <div className="partners-table-wrap">
                    <Table responsive hover className="partners-table">
                      <thead>
                        <tr>
                          <th>logo</th>
                          <th>Partner Name</th>
                          <th>Mobile</th>
                          <th>Branch</th>
                          <th>Services</th>
                          <th>
                            Status
                            <small className="partner-status-heading-hint">
                              Toggle to change
                            </small>
                          </th>
                          <th>Manage</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!this.state.loading &&
                          this.state.partners.map((partner) => (
                            <tr key={partner.id}>
                              <td>
                                {partner.logo ? (
                                  <img
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "50%",
                                    }}
                                    src={partner.logo}
                                    alt={partner.partner_name}
                                    className="partner-logo"
                                  />
                                ) : (
                                  <i className="fa fa-user" />
                                )}
                              </td>
                              <td>{partner.partner_name || "-"}</td>
                              <td>{partner.mobile_number || "-"}</td>
                              <td>
                                {[partner.branch_name, partner.district]
                                  .filter(Boolean)
                                  .join(", ") || "-"}
                              </td>
                              <td>
                                {Array.isArray(partner.partner_features) &&
                                partner.partner_features.length > 0 ? (
                                  <div className="partner-services-list">
                                    {partner.partner_features.map((feature) => (
                                      <div
                                        className="partner-service-summary"
                                        key={feature.type}
                                      >
                                        <strong>
                                          {this.partnerFeatureLabel(
                                            feature.type,
                                          )}
                                        </strong>
                                        {Array.isArray(feature.subtypes) &&
                                          feature.subtypes.length > 0 && (
                                            <span>
                                              {feature.subtypes
                                                .map((subtype) =>
                                                  this.partnerSubtypeLabel(
                                                    feature.type,
                                                    subtype,
                                                  ),
                                                )
                                                .join(", ")}
                                            </span>
                                          )}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                <button
                                  type="button"
                                  role="switch"
                                  aria-checked={Boolean(partner.is_active)}
                                  aria-label={
                                    partner.partner_name +
                                    " is " +
                                    (partner.is_active
                                      ? "active"
                                      : "inactive") +
                                    ". Click to change status."
                                  }
                                  title={
                                    partner.is_active
                                      ? "Currently active. Click to make inactive."
                                      : "Currently inactive. Click to make active."
                                  }
                                  className={
                                    "partner-status-toggle " +
                                    (partner.is_active
                                      ? "is-active"
                                      : "is-inactive")
                                  }
                                  disabled={
                                    this.state.deletingId === partner.id ||
                                    this.state.updatingStatusId === partner.id
                                  }
                                  onClick={() =>
                                    partner.is_active
                                      ? this.confirmDelete(partner)
                                      : this.activatePartner(partner)
                                  }
                                >
                                  <span
                                    className="partner-status-toggle-track"
                                    aria-hidden="true"
                                  >
                                    <span className="partner-status-toggle-knob" />
                                  </span>
                                  <span className="partner-status-toggle-label">
                                    {this.state.deletingId === partner.id ||
                                    this.state.updatingStatusId === partner.id
                                      ? "Updating..."
                                      : partner.is_active
                                        ? "Active"
                                        : "Inactive"}
                                  </span>
                                </button>
                              </td>
                              <td>
                                <div className="partners-manage-actions">
                                  <Button
                                    bsStyle="info"
                                    simple
                                    className="partners-action-button"
                                    onClick={() => this.editPartner(partner)}
                                  >
                                    <i className="fa fa-pencil" /> Edit
                                  </Button>
                                  <Button
                                    bsStyle="info"
                                    simple
                                    className="partners-action-button"
                                    onClick={() =>
                                      this.createPartnerUser(partner)
                                    }
                                  >
                                    <i className="fa fa-user-plus" /> Create User
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        {this.state.loading && (
                          <tr>
                            <td colSpan="7" className="text-center">
                              <div className="partners-empty-state">
                                <i className="fa fa-spinner fa-spin" />
                                <h4>Loading partners...</h4>
                              </div>
                            </td>
                          </tr>
                        )}
                        {!this.state.loading &&
                          this.state.partners.length === 0 && (
                            <tr>
                              <td colSpan="7" className="text-center">
                                <div className="partners-empty-state">
                                  <i
                                    className={
                                      this.state.name ||
                                      this.state.mobile ||
                                      this.state.type ||
                                      this.state.status
                                        ? "fa fa-search"
                                        : "fa fa-users"
                                    }
                                  />
                                  <h4>
                                    {this.state.name ||
                                    this.state.mobile ||
                                    this.state.type ||
                                    this.state.status
                                      ? "No partners found"
                                      : "No partners yet"}
                                  </h4>
                                  <p>
                                    {this.state.name ||
                                    this.state.mobile ||
                                    this.state.status
                                      ? "Try changing or clearing your search fields."
                                      : "Create your first partner to get started."}
                                  </p>
                                </div>
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </Table>
                  </div>
                  {!this.state.loading && this.state.total > 0 && (
                    <div className="partners-pagination">
                      <span className="partners-pagination-summary">
                        Showing {this.state.from}–{this.state.to} of{" "}
                        {this.state.total} partners
                      </span>
                      <Pagination>
                        <Pagination.First
                          disabled={this.state.currentPage === 1}
                          onClick={() => this.loadPartners(1)}
                        />
                        <Pagination.Prev
                          disabled={this.state.currentPage === 1}
                          onClick={() =>
                            this.loadPartners(this.state.currentPage - 1)
                          }
                        />
                        {this.getPageNumbers().map((page) => (
                          <Pagination.Item
                            key={page}
                            active={page === this.state.currentPage}
                            onClick={() => this.loadPartners(page)}
                          >
                            {page}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next
                          disabled={
                            this.state.currentPage === this.state.lastPage
                          }
                          onClick={() =>
                            this.loadPartners(this.state.currentPage + 1)
                          }
                        />
                        <Pagination.Last
                          disabled={
                            this.state.currentPage === this.state.lastPage
                          }
                          onClick={() => this.loadPartners(this.state.lastPage)}
                        />
                      </Pagination>
                    </div>
                  )}
                </div>
              }
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default ViewPartners;
